import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Util } from '@libs/utilities/util';


@Pipe({
    name: 'ngHighlightText',
    standalone: false
})
export class NgHighlightTextPipe implements PipeTransform {

	constructor(
		private sanitizer: DomSanitizer
	) {}

	transform(value: string, text: string): any {
		return this.sanitize(this.replace(value, text));
	}

	private replace(strValue: string, text: string) {

		//0 - return complete string in case of empty
		if (Util.String.isEmpty(text)) return strValue;

		//1 - add to lighter text
		return strValue.replace(new RegExp(`(${text})`, 'gi'), `<span style="color: #a7a7a7;">$1</span>`);
	}

	private sanitize(strValue: string) {
		if (Util.String.isEmpty(strValue)) return '';
		return this.sanitizer.bypassSecurityTrustHtml(strValue);
	}
}
